import { render, staticRenderFns } from "./stockin_detail.vue?vue&type=template&id=c9a310d4&scoped=true"
import script from "./stockin_detail.vue?vue&type=script&lang=js"
export * from "./stockin_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a310d4",
  null
  
)

export default component.exports